import { render } from "./AdministrationContainerView.vue?vue&type=template&id=f65bb394&scoped=true"
import script from "./AdministrationContainerView.vue?vue&type=script&lang=js"
export * from "./AdministrationContainerView.vue?vue&type=script&lang=js"

import "./AdministrationContainerView.vue?vue&type=style&index=0&id=f65bb394&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65bb394"]])

export default __exports__